import React, {Suspense, useEffect, useState} from "react";
import {tabKeys} from "types/enums";
import {residentialNurse} from "types/enums/residential-nurse";
import ListPatient from "./tabs/ListPatient/ListPatient";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {HistoryExamine, Tabs} from "components/common";
import {Spin, TabsProps} from "antd";
import TreatmentInfo from "./tabs/TreatmentInfo/TreatmentInfo";
import {reloadData, setIdDDNT} from "redux/reducer/residentialNurse";
import {setActiveKey, setSiderKey} from "redux/reducer/common";
import CatalogConfig from "./tabs/CatalogConfig/CatalogConfig";

const Treatment = () => {
  document.title = "Điều trị";
  const idDDNT = useAppSelector(state => state.residentialNurse.idDDNT);
  const items: TabsProps["items"] = [
    {
      key: residentialNurse.TREATMENT.LIST_PATIENT,
      label: "Danh sách nội trú",
      children: <ListPatient />,
      active: false,
    },
    {
      key: residentialNurse.TREATMENT.TREATMENT_INFO,
      label: "Thông tin điều trị",
      children: (
        <Suspense fallback={<Spin className="spin" />}>
          <TreatmentInfo />
        </Suspense>
      ),
      disabled: idDDNT !== null ? false : true,
    },
    {
      key: residentialNurse.TREATMENT.EXAM_HISTORY,
      label: "Lịch sử khám bệnh",
      children: <HistoryExamine />,
      disabled: idDDNT !== null ? false : true,
    },
    // {
    //   key: residentialNurse.TREATMENT.CATALOG,
    //   label: "Cấu hình tờ điều trị",
    //   children: <CatalogConfig />,
    // },
  ];
  let dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(setActiveKey(residentialNurse.TREATMENT.LIST_PATIENT));
    dispatch(setIdDDNT(null));
    dispatch(reloadData());
    dispatch(setSiderKey("dieuTri"));
  }, []);
  const activeKey = useAppSelector(e => e.common.activeTab);
  console.log("🚀 ~ Treatment ~ activeKey:", activeKey);
  const isChangeTab = useAppSelector(e => e.residentialNurse.isChangeTab);
  // const [nextActiveKey, setNextActiveKey] = useState<string | null>(
  //   residentialNurse.TREATMENT.LIST_PATIENT
  // );
  // const handleChange = (key) => {
  //   console.log("🚀 ~ handleChange ~ key:", key);
  //   if (isChangeTab == false) {
  //     setNextActiveKey(key);
  //   }
  //   console.log(222);
  // };
  return (
    <div className="residential-treatment page">
      <div className="main">
        <Tabs items={items} accessKey={activeKey} />
      </div>
    </div>
  );
};

export default Treatment;
